import { render, staticRenderFns } from "./SimpleTooltip.vue?vue&type=template&id=ed65f87c&"
import script from "./SimpleTooltip.vue?vue&type=script&setup=true&lang=js&"
export * from "./SimpleTooltip.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports